var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 12.2729C1.75 6.39345 6.75353 1.56836 13 1.56836C19.2465 1.56836 24.25 6.39345 24.25 12.2729C24.25 18.1524 19.2465 22.9774 13 22.9774C6.75353 22.9774 1.75 18.1524 1.75 12.2729ZM13 0.0683594C5.99163 0.0683594 0.25 5.50002 0.25 12.2729C0.25 19.0458 5.99163 24.4774 13 24.4774C20.0084 24.4774 25.75 19.0458 25.75 12.2729C25.75 5.50002 20.0084 0.0683594 13 0.0683594ZM18.5892 7.90666C18.8885 7.62031 18.899 7.14555 18.6126 6.84626C18.3263 6.54697 17.8515 6.53648 17.5522 6.82283L12.9961 11.1819L8.51465 6.95444C8.21334 6.67021 7.73867 6.68405 7.45444 6.98535C7.17021 7.28666 7.18405 7.76133 7.48535 8.04556L11.9109 12.2203L7.48152 16.4581C7.18222 16.7444 7.17173 17.2192 7.45808 17.5185C7.74443 17.8178 8.21919 17.8283 8.51848 17.5419L13.0034 13.2509L17.5561 17.5456C17.8574 17.8298 18.332 17.816 18.6163 17.5146C18.9005 17.2133 18.8867 16.7387 18.5854 16.4544L14.0887 12.2126L18.5892 7.90666Z",
    fill: "#FF5858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.1546f1cb20a810bd2bf691425b2b1cf2.svg";
export { ForwardRef as ReactComponent };